import React from 'react';

import { Sheet } from '../../../mobile/structural/sheet/Sheet';
import useSheet from '../../../mobile/structural/sheet/hooks/useSheet';
import { SheetId } from '../../../mobile/structural/sheet/sheetTypes';

import './ElementModalErrorSheet.scss';
import NotFoundElementModal from './NotFoundElementModal';
import ElementAccessDeniedModal from './ElementAccessDeniedModal';
import NoModalComponentElementModal from './NoModalComponentElementModal';
import PageContent from '../../../components/modal/PageContent';
import { useTranslator } from '../../../components/i18n/useTranslator';

type ElementErrorSheetProps = {
    close: (event: any) => void;
};

const ElementErrorSheet: React.FC<ElementErrorSheetProps> = ({ children, close }) => {
    const translate = useTranslator('modal', 'elementErrorSheet');

    const handleClose = () => {
        close(null);
    };

    const sheetProps = useSheet(SheetId.RouteModal, undefined, {
        openByDefault: true,
        onCloseTransitionEnd: handleClose,
    });

    return (
        <Sheet {...sheetProps} className="ElementModalErrorSheet" defaultSnapPoint={1}>
            <Sheet.Overlay />
            <Sheet.Panel>
                <Sheet.Header>
                    <Sheet.CloseButton>{translate('closeButton')}</Sheet.CloseButton>
                </Sheet.Header>
                <Sheet.Content>
                    <PageContent className="sheet-content">{children}</PageContent>
                </Sheet.Content>
            </Sheet.Panel>
        </Sheet>
    );
};

export const NotFoundElementSheet: React.FC<{
    close: () => void;
}> = ({ close }) => (
    <ElementErrorSheet close={close}>
        <NotFoundElementModal />
    </ElementErrorSheet>
);

export const ElementAccessDeniedSheet: React.FC<{
    close: () => void;
}> = ({ close }) => (
    <ElementErrorSheet close={close}>
        <ElementAccessDeniedModal />
    </ElementErrorSheet>
);

export const NoModalComponentElementSheet: React.FC<{
    close: () => void;
}> = ({ close }) => (
    <ElementErrorSheet close={close}>
        <NoModalComponentElementModal />
    </ElementErrorSheet>
);

export default ElementErrorSheet;
